import { globalAppGQLFields } from './globalApp.fields.js';
const BASIC_APP_COLLABORATOR_FIELDS = {};
const ALL_APP_COLLABORATOR_FIELDS = {
    app: 'basic',
};
export const appCollaboratorGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_APP_COLLABORATOR_FIELDS;
    if (fields === 'all')
        fields = ALL_APP_COLLABORATOR_FIELDS;
    return `
    id
    appId
    email
    createdAt
    type
    ${fields.app
        ? `
      app {
        ${globalAppGQLFields(fields.app)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=appCollaborator.fields.js.map